var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 1.41675L13 0.166748L11.75 1.41675L10.5 0.166748L9.25 1.41675L8 0.166748L6.75 1.41675L5.5 0.166748L4.25 1.41675L3 0.166748V11.8334H0.5V14.3334C0.5 15.7167 1.61667 16.8334 3 16.8334H13C14.3833 16.8334 15.5 15.7167 15.5 14.3334V0.166748L14.25 1.41675ZM13.8333 14.3334C13.8333 14.7917 13.4583 15.1667 13 15.1667C12.5417 15.1667 12.1667 14.7917 12.1667 14.3334V11.8334H4.66667V2.66675H13.8333V14.3334ZM10.5 4.33382V6.00049H5.5V4.33382H10.5ZM13 4.33382H11.3333V6.00049H13V4.33382ZM10.5 6.83301V8.49967H5.5V6.83301H10.5ZM13 6.83301H11.3333V8.49967H13V6.83301Z",
    fill: "#9BB8C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.3f8af8bccd80fd5a97d0631826f8a4e3.svg";
export { ForwardRef as ReactComponent };